<template>
    <div>
        <trip-editor :trip="trip"/>
    </div>
</template>

<script>
    import TripEditor from '../custom-components/TripEditor.vue'
    
    export default {
        props: [
            'id'
        ],
        components: {
            'trip-editor': TripEditor
        },
        computed: {
            trip () {
                return this.$privateReactiveStore.getTrip(this.id);
            }
        }
    }
</script>